export default __webpack_public_path__ + "static/media/gallery_04.fda36d36.jpg";